import { render, staticRenderFns } from "./ImagesCategory.vue?vue&type=template&id=3b7a5352&scoped=true&"
import script from "./ImagesCategory.vue?vue&type=script&lang=js&"
export * from "./ImagesCategory.vue?vue&type=script&lang=js&"
import style0 from "./ImagesCategory.vue?vue&type=style&index=0&id=3b7a5352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a5352",
  null
  
)

export default component.exports